import { Button, Typography } from '@mui/material';
import { PublicNavbar } from '@/components/Navbar/PublicNavbar';
import { Description, ErrorWrapper } from './styles';
import error from '@/assets/error.png';
import { RouteMap } from '@/routes/Routes';
import { Link } from 'react-router-dom';

const Error = () => {
  return (
    <>
      <PublicNavbar />
      <ErrorWrapper>
        <Typography variant="h4" align="center">
          Oh No! Error 404
        </Typography>
        <Description variant="h5">
          Oops! That page seems to have taken a detour. Let us guide you back to your destination.
        </Description>
        <img src={error} alt="Error 404" style={{ margin: '63px 0' }} />
        <Button variant="contained" to={RouteMap.ROOT} component={Link}>
          Go Back Home
        </Button>
      </ErrorWrapper>
    </>
  );
};

export default Error;
